import { Permission } from '@today/types'

/** Which customer actions and tabs the viewer may see (TO-418 customer-ui REQ-002). */
export interface CustomerCapabilities {
	read: boolean
	write: boolean
	piiRead: boolean
	assign: boolean
	recordConsent: boolean
	anonymize: boolean
	activity: boolean
}

/** The pure permission map: an action the viewer lacks is not rendered. */
export const customerCapabilities = (permissions: readonly string[]): CustomerCapabilities => {
	const has = (permission: Permission) => permissions.includes(permission)
	return {
		read: has(Permission.CUSTOMER_READ),
		write: has(Permission.CUSTOMER_WRITE),
		piiRead: has(Permission.CUSTOMER_PII_READ),
		assign: has(Permission.CUSTOMER_ASSIGN),
		recordConsent: has(Permission.CUSTOMER_CONSENT_WRITE),
		anonymize: has(Permission.CUSTOMER_ANONYMIZE),
		activity: has(Permission.AUDIT_READ),
	}
}
